import React, { useState, useMemo } from 'react';
import Alert from 'components/ui/Alert';
import { Link } from 'react-router-dom';
import ArrowRightIcon from 'components/v2/icons/ArrowRightIcon';

export default function OrderRtbBanner({ order, className = '' }) {
  const [visible, setVisible] = useState(true);

  const { orderLinkHref, orderLinkText } = useMemo(() => {
    if (!order) {
      return { orderLinkHref: null, orderLinkText: null };
    }
    const orderObj = order;
    const orderId = typeof orderObj === 'object' ? orderObj?._id : orderObj;
    const linkText =
      typeof orderObj === 'object'
        ? orderObj?.order_id || orderObj?._id
        : orderObj;
    return {
      orderLinkHref: orderId ? `/orders/${orderId}` : null,
      orderLinkText: linkText || null,
    };
  }, [order]);

  if (!visible || !orderLinkHref || !orderLinkText) {
    return null;
  }

  return (
    <Alert
      className={`mt-4 mb-4 ${className}`}
      type="info"
      canClose
      onClose={() => setVisible(false)}
    >
      <div className="flex items-center gap-6">
        <span>
          Invoice creation is now available directly from the Order Detail page
        </span>
        <Link to={orderLinkHref} className="inline-flex items-center">
          {orderLinkText}
          <ArrowRightIcon className="ml-1 w-4 h-4" />
        </Link>
      </div>
    </Alert>
  );
}
